/**
 * Map UI study card ids to API study group keys.
 * PatientDetailPage uses `study_YYYYMMDD` / `study_<uid>` while the files
 * endpoint expects `date:YYYYMMDD` / `uid:<uid>` / `wl:<id>`.
 */
export function normalizeStudyFilesGroupKey(groupKey: string): string {
  const raw = (groupKey || '').trim();
  if (!raw) return '';
  if (
    raw.startsWith('wl:') ||
    raw.startsWith('uid:') ||
    raw.startsWith('date:')
  ) {
    return raw;
  }
  const dateMatch = /^study_(\d{8})$/i.exec(raw);
  if (dateMatch) {
    return `date:${dateMatch[1]}`;
  }
  if (raw.startsWith('study_') && raw.length > 6) {
    const rest = raw.slice(6);
    // DICOM UIDs are dotted numeric; keep other study_* ids untouched.
    if (/^\d+(?:\.\d+)+$/.test(rest)) {
      return `uid:${rest}`;
    }
  }
  if (raw.startsWith('WLI_')) {
    return `wl:${raw}`;
  }
  return raw;
}

/** Build URL for GET /patients/{id}/studies/{group_key}/files. */
export function buildPatientStudyFilesUrl(
  patientId: string,
  groupKey: string,
  opts?: { scheduledDate?: string }
): string {
  const encoded = encodeURIComponent(normalizeStudyFilesGroupKey(groupKey));
  const params = new URLSearchParams();
  if (opts?.scheduledDate) {
    params.set('scheduled_date', opts.scheduledDate);
  }
  const qs = params.toString();
  return `/api/v1/patients/${patientId}/studies/${encoded}/files${qs ? `?${qs}` : ''}`;
}
